export const StorageKey = {
    licenceFile: 'oldData.dtd',
    settings: 'settings',
}